import type { Variation } from '@shared/types/types.ts';
import type { DefaultLayout } from '@tilelist/layouts/default-layout/DefaultLayout.ts';
import {
    type LayoutImageIntents,
    getLayoutImages,
    shouldDimCutoutImage,
} from '@tilelist/layouts/mapping/LayoutImages.ts';
import { mapLink } from '@tilelist/layouts/mapping/ProductLink.ts';
import { mapShortTitle } from '@tilelist/layouts/mapping/ProductTitle.ts';

export type { DefaultLayout } from '@tilelist/layouts/default-layout/DefaultLayout.ts';

export function createDefaultLayout(
    variation: Variation,
    showTopInfos: boolean,
    intents?: LayoutImageIntents,
): DefaultLayout {
    const patchedVariation: Variation = {
        ...variation,
        topInfos: showTopInfos && variation.topInfos?.length ? variation.topInfos : undefined,
    };
    const { images, primaryImage } = getLayoutImages(variation, intents);
    const shouldDim = shouldDimCutoutImage(variation, intents);
    return {
        variation: patchedVariation,
        title: mapShortTitle(variation),
        link: mapLink(variation),
        images,
        primaryImage,
        shouldDim,
    };
}
